//Import Core
import React, { useState, useEffect } from "react";

//Import Components
import Sidebar from "../../Components/Common/SideBar";
import Header from "../../Components/Common/Header";
import FooterColorLine from "Components/FooterColorLine";

//Import Scss
import "./styles.scss";

export function MainLayout({ children, pageName }) {
  return (
    <>
      <div className="layoutContainer">
        {/* Sidebar should be fixed */}
        <Sidebar />
        {/* Main content with header fixed and children scrollable */}
        <div className="contentWrapper">
          <Header pageName={pageName} />
          <div className="scrollableContent">{children}</div>
          <div className="footerMainContainer" style={{height:"5px", width:"100vw"}}>
        <FooterColorLine/>
      </div>
        </div> 
      </div>
    </>
  );
}

export default MainLayout;
